import {directive as onClickaway} from 'vue-clickaway';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import StarRating from 'vue-star-rating'
import stepItem from '../../components/step-item/index.vue'
import TooltipLayout from '@/components/atoms/tooltip-layout/index.vue'
import {seo} from '@/mixins/seo'

export default {
    name: 'action-plan-detail',
    mixins: [seo],
    directives: {
        onClickaway: onClickaway,
    },
    props: {},
    data() {
        return {
            active: false,
            value: '',
            coordsPoints: [],
            heightsText: [],
            heightHeader: 0,
            subHeightHeader: 0,
            showHeader: false,
            isNavigationScroll: false,
            index: 0,
            currentProgressIndex: 0
        }
    },
    components: {
        StarRating,
        stepItem,
        TooltipLayout
    },
    computed: {
        ...mapGetters({
            activeStep: 'actionPlans/activeStep',
            currentItem: 'actionPlans/currentItem',
            isLoading: 'actionPlans/isLoading',
            isProgressLoading: 'actionPlans/isProgressLoading',

        }),
        progressPercent() {
            return Math.round(((this.activeStep + 1) / this.listLength) * 100)
        },
        listLength() {
            return this.currentItem.contents.data.length
        },
        list() {
            return this.currentItem.contents.data
        },
        statusProgressItem() {
            if (!this.currentItem.userActionPlan.data.hasOwnProperty('status') || this.currentItem.userActionPlan.data.completedSteps === 0) return '';
            return this.currentItem.userActionPlan.data.status
        }
    },
    watch: {
        activeStep() {
            window.scrollTo(0, 0);
            if (!this.activeStep) {
                this.showHeader = false;
                window.addEventListener('scroll', this.handleScroll);
                this.getCoordsPoints();
                this.getCoordsText();
                this.init();
            } else {
                window.removeEventListener('scroll', this.handleScroll);
            }
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            if (!this.activeStep) {
                this.getCoordsPoints();
                this.getCoordsText();
                this.init();
            }
        });

        this.fetchData({slug: this.$route.params.slug}).then(response => {
            Object.assign(this.seo, this.currentItem.seo.data)
            this.$emit('updateHead')
            // start action plan(set initial index progress)
            if (!response.userActionPlan.data.hasOwnProperty('lastStartedContentId')) {
                this.updateProgress({
                    id: response.id,
                    type: 'start'
                }).then(() => {
                    this.updateProgress({
                        id: this.currentItem.id,
                        completedId: this.currentItem.contents.data[0].id,
                        type: 'next'
                    });
                });
                this.currentProgressIndex = 0;
            } else {
                if (response.userActionPlan.data.status === 'completed') {
                    this.setActiveStep(0);
                    this.currentProgressIndex = this.listLength;
                } else {
                    if (!response.userActionPlan.data.lastStartedContentId) {
                        this.currentProgressIndex = 0;
                        this.updateProgress({
                            id: this.currentItem.id,
                            completedId: this.currentItem.contents.data[0].id,
                            type: 'next'
                        });
                    } else {
                        this.currentProgressIndex = this.currentItem.contents.data.findIndex(e => e.id === response.userActionPlan.data.lastStartedContentId);
                        this.setActiveStep(this.currentProgressIndex);
                    }
                }
            }
            // end

            if (!this.activeStep) {
                // sorry
                document.querySelector('.tooltip-layout__wrap').style.display = 'none';
                // end sorry
                window.addEventListener('scroll', this.handleScroll);
                setTimeout(() => {
                    this.getCoordsPoints();
                    this.getCoordsText();
                    this.init();
                }, 400)
            }
        })
    },
    beforeRouteLeave(to, from, next) {
        if (!from.name.includes(to.name)) {
            this.changeCategory()
        }
        next();
    },
    methods: {
        ...mapActions({
            fetchData: 'actionPlans/GET_LIST_ITEM',
            updateProgress: 'actionPlans/UPDATE_PROGRESS',
        }),
        ...mapMutations({
            setActiveStep: 'actionPlans/CHANGE_STEP',
            setCurrentItem: 'actionPlans/SET_ITEM',
            changeCategory: 'actionPlans/CHANGE_CATEGORY',
            setCategories: 'education/SET_CATEGORIES',
        }),
        stepTo(params) {
            const {direction, index} = params;
            this.btnStepHandle(false, direction, true, index)
        },
        setStep(index) {
            if (index === this.activeStep) return;
            this.btnStepHandle(true);
            this.setActiveStep(index);
        },
        findAndSetCurrentIndex(i) {
            const id = this.list[i].id;
            const index = this.currentItem.contents.data.findIndex(e => e.id === id);
            if (index > this.currentProgressIndex) {
                this.currentProgressIndex = index;
            }
        },
        completeItem() {
            this.updateProgress({
                id: this.currentItem.id,
                type: 'complete',
                _method: 'patch'
            });
        },
        btnStepHandle(isPoint = false, key, childrenEmit = false, childrenIndex) {
            this.isNavigationScroll = true;
            let index = childrenEmit ? childrenIndex - 1 : this.activeStep;
            if (!isPoint) {
                if (key === 'prev') {
                    this.setActiveStep(--index)
                } else {
                    this.findAndSetCurrentIndex(index + 1);

                    const id = this.list[index + 1].id;
                    const nextIndex = this.currentItem.contents.data.findIndex(e => e.id === id);

                    if (this.currentProgressIndex === nextIndex && this.currentItem.userActionPlan.data.status !== 'completed') {
                        this.updateProgress({
                            id: this.currentItem.id,
                            completedId: this.currentItem.contents.data[index + 1].id,
                            type: 'next'
                        });
                    }
                    this.setActiveStep(++index);
                }
            }
        },
        handleScroll() {
            const h = document.documentElement,
                b = document.body,
                st = 'scrollTop',
                sh = 'scrollHeight';

            const scrolled = (h[st] + this.heightHeader + ((this.subHeightHeader) / 1.7) - this.heightsText[0]);
            this.showHeader = this.coordsPoints[0] <= scrolled;
        },
        getCoordsPoints() {
            const arr = [];
            if (document.getElementById('step-1')) {
                arr.push(this.trackingPotionElement(document.getElementById('step-1')));
                this.coordsPoints = arr;
            }
        },
        getCoordsText() {
            const arr = [];
            if (document.getElementById('step-text-1')) {
                arr.push(document.getElementById('step-text-1').clientHeight);
                this.heightsText = arr;
            }
        },
        trackingPotionElement(element) {
            let body = document.body,
                win = document.defaultView,
                docElem = document.documentElement,
                box = document.createElement('div');
            box.style.paddingLeft = box.style.width = '1px';
            body.appendChild(box);
            let isBoxModel = box.offsetWidth === 2;
            body.removeChild(box);
            box = element.getBoundingClientRect();
            let clientTop = docElem.clientTop || body.clientTop || 0,
                scrollTop = win.pageYOffset || isBoxModel && docElem.scrollTop || body.scrollTop;
            return box.top + scrollTop - clientTop;
        },
        init() {
            if (!document) return;
            this.heightHeader = document.querySelector('.header-wrap').clientHeight || 52;
            this.subHeightHeader = document.querySelector('.action-header__content').clientHeight / 2 || 110;
        },
        declensionWord() {
            let titles = [this.$t('stepWord1'), this.$t('stepWord2'), this.$t('stepWord3')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(this.listLength % 100 > 4 && this.listLength % 100 < 20) ? 2 : cases[(this.listLength % 10 < 5) ? this.listLength % 10 : 5]];
        },
        navigateToList() {
            try {
                this.$router.push({name: 'action-plans'})
            } catch (e) {
            }
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        this.setCurrentItem(null);
        this.setActiveStep(0);
    }
}
